export const roleList = [
  { name: 'GENERAL_ADMINISTRATOR', value: 'GENERAL_ADMINISTRATOR' },
  { name: 'Admin', value: 'ADMIN' },
  { name: 'Finance', value: 'FINANCE' },
  { name: 'Developer', value: 'DEVELOPER' },
  { name: 'Read only', value: 'READ_ONLY' },
  { name: 'Transactions', value: 'TRANSACTIONS' },
  { name: 'Payables', value: 'PAYABLES' },
];

export const WORKSPACE_VIEW_ROLE_LIST = [
  { name: 'Finance', value: 'VIEW_FINANCE' },
  { name: 'Read only', value: 'READ_ONLY' },
  { name: 'Payment controller', value: 'PAYMENT_CONTROLLER' },
];

export const typesList = [
  { name: 'Inflow', value: 'INFLOW' },
  { name: 'Outflow', value: 'OUTFLOW' },
];

export const linkTypesList = [
  { name: 'BANK', value: 'BANK' },
  { name: 'PI', value: 'PI' },
  { name: 'OF', value: 'OF' },
];

export const linkStatusList = [
  { name: 'Active', value: 'ACTIVE' },
  { name: 'Inactive', value: 'INACTIVE' },
  { name: 'Unauthorized', value: 'UNAUTHORIZED' },
  { name: 'Pending', value: 'PENDING' },
  { name: 'Processing Accounts', value: 'UPDATING_ASSETS' },
  { name: 'Processing Transactions', value: 'UPDATING_TRANSACTIONS' },
  { name: 'Pending Device Registration', value: 'PENDING_DEVICE_REGISTRATION' },
];

export const severitiesList = [
  { name: 'Lowest', value: 'LOWEST', color: '#98D8FF' },
  { name: 'Low', value: 'LOW', color: '#56BFB5' },
  { name: 'Medium', value: 'MEDIUM', color: '#FBB040' },
  { name: 'High', value: 'HIGH', color: '#FA8572' },
  { name: 'Highest', value: 'HIGHEST', color: '#F16896' },
];

export const transactionStatusList = [
  { name: 'Approved', value: 'APPROVED' },
  { name: 'Expired', value: 'EXPIRED' },
  { name: 'Created', value: 'CREATED' },
  { name: 'Blocked', value: 'BLOCKED' },
  { name: 'Refused', value: 'REFUSED' },
  { name: 'Pending', value: 'PENDING' },
];

export const pixStatusList = [
  { name: 'PIX_STATUS_EXECUTED', value: 'EXECUTED' },
  { name: 'PAYMENT_STATUS_SCHEDULED', value: 'SCHEDULED' },
  { name: 'PIX_STATUS_UNDER_REVIEW', value: 'UNDER_REVIEW' },
];

export const paymentsStatusList = [
  { name: 'PAYMENT_STATUS_NOT_EXECUTED', value: 'NOT_EXECUTED' },
  { name: 'PAYMENT_STATUS_EXECUTED', value: 'EXECUTED' },
  { name: 'PAYMENT_STATUS_AUTHORIZED', value: 'AUTHORIZED' },
  { name: 'PAYMENT_STATUS_PARTIALLY_AUTHORIZED', value: 'PARTIALLY_AUTHORIZED' },
  { name: 'PAYMENT_STATUS_PENDING_AUTHORIZATION', value: 'PENDING_AUTHORIZATION' },
  { name: 'PAYMENT_STATUS_PENDING_EXECUTION', value: 'PENDING_EXECUTION' },
  { name: 'PAYMENT_STATUS_UNKNOWN', value: 'UNKNOWN' },
  { name: 'PAYMENT_STATUS_SCHEDULED', value: 'SCHEDULED' },
  { name: 'PAYMENT_STATUS_BLOCKED', value: 'BLOCKED' },
  { name: 'PAYMENT_STATUS_CANCELED', value: 'CANCELED' },
  { name: 'PAYMENT_STATUS_REFUNDED', value: 'REFUNDED' },
  { name: 'PAYMENT_STATUS_REJECTED', value: 'REJECTED' },
];

export const downloadableStatusList = [
  { name: 'DOWNLOADABLE_STATUS_PENDING', value: 'PENDING' },
  { name: 'DOWNLOADABLE_STATUS_REQUESTED', value: 'REQUESTED' },
  { name: 'DOWNLOADABLE_STATUS_IN_PROGRESS', value: 'IN_PROGRESS' },
  { name: 'DOWNLOADABLE_STATUS_FAILED', value: 'FAILED' },
  { name: 'DOWNLOADABLE_STATUS_PROCESSED', value: 'PROCESSED' },
];

export const paymentTypeList = [
  { name: 'TICKET', value: 'TICKET' },
  { name: 'PIX', value: 'PIX' },
  { name: 'TED', value: 'TED' },
  { name: 'DOC', value: 'DOC' },
  { name: 'BATCH', value: 'BATCH' },
  { name: 'SERVICE', value: 'SERVICE' },
  { name: 'OTHER', value: 'OTHER' },
];

export const rulesEndList = [
  { name: 'Never', value: 'never' },
  { name: 'Date', value: 'date' },
  { name: 'When condition is met', value: 'oneshot' },
];

export const categoriesColors = [
  '#CAD3FE',
  '#FFE2B6',
  '#D2EEFF',
  '#FDC6D8',
  '#C0FBF5',
  '#F3D0FF',
  '#FFF4E0',
  '#D6EDD4',
  '#DFD3C3',
  '#ECF2F9',
  '#D2FFC7',
  '#EFEFEF',
  '#FFE0DB',
  '#EEE6FF',
  '#FFE5C9',
  '#FFF2B1',
  '#C4C1E0',
  '#D7FAFF',
  '#FFEEFB',
  '#E8FFC1',
];

export const viewListMap = {
  CURRENCY: 'currency',
  INSTITUTION: 'institution',
  INSTRUMENT_TYPE: 'instrumentType',
  OWNER: 'owner',
};

export const viewListMapAccounts = {
  CURRENCY: 'CURRENCIES',
  INSTITUTION: 'INSTITUTIONS',
  OWNER: 'OWNERS',
  OWNERS_DETAIL: 'OWNERS_DETAIL',
  ACCOUNT_GROUP: 'ACCOUNT_GROUPS',
};

export const cashPositionViewList = [
  { name: 'Currency', value: 'CURRENCY' },
  { name: 'Institution', value: 'INSTITUTION' },
  { name: 'Owner', value: 'OWNER' },
  { name: 'Account group', value: 'ACCOUNT_GROUP' },
];

export const consolidatedViewList = [
  { name: 'Owner', value: 'OWNER' },
  { name: 'Account group', value: 'ACCOUNT_GROUP' },
];

export const accountsViewList = [
  { name: 'Currency', value: 'CURRENCY' },
  { name: 'Institution', value: 'INSTITUTION' },
  { name: 'Owner', value: 'OWNER' },
];

export const forecastsViewList = [
  { name: 'Currency', value: 'CURRENCY' },
  { name: 'Institution', value: 'INSTITUTION' },
  { name: 'Owner', value: 'OWNER' },
  { name: 'Account group', value: 'ACCOUNT_GROUP' },
];

export const linkDetailViewList = [
  { name: 'Currency', value: 'CURRENCY' },
  { name: 'Owner', value: 'OWNERS_DETAIL' },
];

export const investmentsViewList = [
  { name: 'Currency', value: 'CURRENCY' },
  { name: 'Institution', value: 'INSTITUTION' },
  { name: 'Owner', value: 'OWNER' },
  { name: 'Type', value: 'INSTRUMENT_TYPE' },
];

export const applicationsViewListMap = {
  INSTITUTION: 'institution',
  OWNER: 'owner',
  ACCOUNT: 'account',
  NONE: 'none',
};

export const applicationsViewList = [
  { name: 'Institution', value: 'INSTITUTION' },
  { name: 'Owner', value: 'OWNER' },
  { name: 'Account', value: 'ACCOUNT' },
  { name: 'None', value: 'NONE' },
];

export const schedulePeriodList = [
  { name: 'PERIOD_ONE_TIME', value: 'ONE_TIME' },
  { name: 'PERIOD_WEEKDAY', value: 'WEEKDAY' },
  { name: 'PERIOD_MONDAY_TO_SATURDAY', value: 'MONDAY_TO_SATURDAY' },
  { name: 'PERIOD_EVERYDAY', value: 'EVERYDAY' },
  { name: 'PERIOD_WEEKLY', value: 'WEEKLY' },
  { name: 'PERIOD_WEEKEND', value: 'WEEKEND' },
];

export const syncTypeList = [
  { name: 'SYNC_LAST_MONTH', value: 'SYNC_LAST_MONTH' },
  { name: 'SYNC_LAST_WEEK', value: 'SYNC_LAST_WEEK' },
  { name: 'SYNC_NOW', value: 'SYNC_NOW' },
];

export const accountCategoriesList = [
  { value: 'SAVING' },
  { value: 'CHECKING' },
  { value: 'INVESTMENT' },
  { value: 'FOOD' },
  { value: 'FIXED_DEPOSIT' },
];

export const instrumentTypesList = [
  { name: 'STOCKS', value: 'STOCKS' },
  { name: 'BOND', value: 'BOND' },
  { name: 'FUND', value: 'FUND' },
  { name: 'DEPOSIT', value: 'DEPOSIT' },
  { name: 'COMMITTED', value: 'COMMITTED' },
  { name: 'COE', value: 'COE' },
];

export const subCategoriesList = [
  { name: 'CDB', value: 'CDB' },
  { name: 'LF', value: 'LF' },
  { name: 'RDC', value: 'RDC' },
  { name: 'LC', value: 'LC' },
  { name: 'CR', value: 'CR' },
  { name: 'DEBENTURES', value: 'DEBENTURES' },
];

export const reportFormatList = [
  { name: 'OFX', value: 'OFX' },
  { name: 'PDF', value: 'PDF' },
];

export const reportStatusList = [
  { name: 'SUCCESS', value: 'SUCCESS' },
  { name: 'FAIL', value: 'FAIL' },
  { name: 'NO_ROWS', value: 'NO_ROWS' },
];

export const transactionModeList = [
  { name: 'MANUAL', value: 'MANUAL' },
  { name: 'AUTOMATIC', value: 'AUTOMATIC' },
  { name: 'MANUAL_DEPOSIT', value: 'MANUAL_DEPOSIT' },
  { name: 'MANUAL_COMMITTED', value: 'MANUAL_COMMITTED' },
];

export const upToDateList = [
  { name: 'UP_TO_DATE_YES', value: 'True' },
  { name: 'UP_TO_DATE_NO', value: 'False' },
];

export const areaActivityList = [
  { name: 'Finance', value: 'FINANCE' },
  { name: 'Treasury', value: 'TREASURY' },
  { name: 'Accounting', value: 'ACCOUNTING' },
  { name: 'FP&A', value: 'FP_A' },
];

export const clientPositionList = [
  { name: 'Analyst', value: 'ANALYST' },
  { name: 'Coordinator', value: 'COORDINATOR' },
  { name: 'Manager', value: 'MANAGER' },
  { name: 'Director', value: 'DIRECTOR' },
  { name: 'Specialist', value: 'SPECIALIST' },
];

export const frequencyCashAnalysisList = [
  { name: 'Daily', value: 'DAILY' },
  { name: 'Weekly', value: 'WEEKLY' },
  { name: 'Monthly', value: 'MONTHLY' },
];

export const clientProductsList = [
  { name: 'Deposit', value: 'deposit' },
  { name: 'Committed', value: 'committed' },
  { name: 'Fund', value: 'fund' },
];
